type Props = {
  lat: number;
  lng: number;
  content: any;
};

export default function MapMarker(props: Props) {
  return props.content;
}
